import { FormEvent, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Search.module.css';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  groupPageChanged,
  groupKeywordChanged,
  studentPageChanged,
  studentKeywordChanged,
  selectStudentSearch,
  selectGroupSearch,
  selectTeacherSearch,
  teacherKeywordChanged,
  teacherPageChanged,
} from '../../../features/classroomSlice';

import {
  DELETE,
  SEARCH,
  SEARCH_INPUT_PLACEHOLDER,
  TOTAL,
} from '../../../constants';
import { isMobile } from '../../../utils/util';
import Button from '../../../components/Button';

interface Search {
  type: 'student' | 'group' | 'teacher';
  keyword: string;
  total: number;
  toggleAddButton?: () => void;
}

export default function Search({
  type,
  keyword,
  total,
  toggleAddButton,
}: Search) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputVal, setInputVal] = useState(keyword);
  const [isShowInput, setIsShowInput] = useState(false);

  const selectedKeyword = useAppSelector(
    type === 'student'
      ? selectStudentSearch
      : type === 'group'
      ? selectGroupSearch
      : selectTeacherSearch
  );

  const submitKeyword = async (e: FormEvent) => {
    e.preventDefault();
    if (type === 'student') {
      dispatch(studentKeywordChanged(inputVal));
      dispatch(studentPageChanged(0));
    } else if (type === 'group') {
      dispatch(groupKeywordChanged(inputVal));
      dispatch(groupPageChanged(0));
    } else {
      dispatch(teacherKeywordChanged(inputVal));
      dispatch(teacherPageChanged(0));
    }
  };

  const resetKeyword = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
      setInputVal('');
    }
  };

  const toggleInput = () => {
    setIsShowInput(!isShowInput);
    toggleAddButton && toggleAddButton();
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = selectedKeyword;
    }
  }, [selectedKeyword]);

  return (
    <form role="search" onSubmit={submitKeyword}>
      <div className={cx('search_area', { active: isShowInput })}>
        <label htmlFor="">
          <span className={cx('blind')}>{SEARCH}</span>
          {isMobile && !isShowInput ? null : (
            <input
              type="text"
              className={cx('search_t')}
              placeholder={SEARCH_INPUT_PLACEHOLDER}
              onChange={({ target }) => setInputVal(target.value)}
              defaultValue={keyword}
              ref={inputRef}
            />
          )}
          {isShowInput && inputVal && (
            <Button
              name={DELETE}
              classnames={['search_del']}
              handleClick={resetKeyword}
            />
          )}
          <button
            type={isMobile ? 'button' : 'submit'}
            className={cx('btn', 'icon_search')}
            {...(isMobile && {
              onClick: toggleInput,
            })}
          >
            {SEARCH}
          </button>
        </label>
        {!isShowInput && (
          <span className={cx('result_search_text')}>
            {TOTAL.replace('{N}', total?.toString())}
          </span>
        )}
      </div>
    </form>
  );
}
